import { Grid, ListItem, Typography } from "@mui/material";
import React from "react";
import { useThemeProvider } from "../../../providers/ThemeProvider";

export const TransactionDetailsListViewItemComponent = ({
  alignItems,
  title,
  data,
  name,
}) => {
  const theme = useThemeProvider();
  return (
    <ListItem
      alignItems={alignItems}
      className={theme.styles.classes.componentsListItemMainExploreProduct}
    >
      <Grid container wrap="nowrap">
        <Grid item xs="auto">
          <Typography variant="title">{title}</Typography>
        </Grid>
        <Grid
          container
          item
          xs
          paddingX={3}
          direction="column"
          justifyContent="center"
          alignItems="flex-end"
        >
          <Typography variant="title" style={{ wordWrap: "anywhere" }}>
            {(data && name in data && data[name]) || ""}
          </Typography>
        </Grid>
      </Grid>
    </ListItem>
  );
};

export const TransactionDetailsReceiptListViewItemComponent = ({
  alignItems,
  title,
  data,
  name,
}) => {
  const theme = useThemeProvider();
  return (
    <ListItem alignItems={alignItems}>
      <Grid container direction="column">
        <Grid
          container
          item
          direction="column"
          justifyContent="center"
          alignItems="flex-start"
        >
          <Typography variant="title">{title}</Typography>
        </Grid>
        <Grid
          container
          item
          direction="column"
          justifyContent="center"
          alignItems="flex-start"
        >
          <Typography variant="caption" style={{ wordWrap: "anywhere" }}>
            {(data && name in data && data[name]) || ""}
          </Typography>
        </Grid>
      </Grid>
    </ListItem>
  );
};
